/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BenutzerAktivierenRequest } from '../model/benutzerAktivierenRequest';
// @ts-ignore
import { BenutzerAnlegenRequest } from '../model/benutzerAnlegenRequest';
// @ts-ignore
import { BenutzerBackendAdminRequest } from '../model/benutzerBackendAdminRequest';
// @ts-ignore
import { BenutzerEmailAktualisierenRequest } from '../model/benutzerEmailAktualisierenRequest';
// @ts-ignore
import { BenutzerIdentifier } from '../model/benutzerIdentifier';
// @ts-ignore
import { BenutzerNameRequest } from '../model/benutzerNameRequest';
// @ts-ignore
import { BenutzerRequest } from '../model/benutzerRequest';
// @ts-ignore
import { BenutzerSichtbarkeitRequest } from '../model/benutzerSichtbarkeitRequest';
// @ts-ignore
import { BenutzerSperrenRequest } from '../model/benutzerSperrenRequest';
// @ts-ignore
import { BenutzerTelefonEntfernenRequest } from '../model/benutzerTelefonEntfernenRequest';
// @ts-ignore
import { BenutzerTelefonRequest } from '../model/benutzerTelefonRequest';
// @ts-ignore
import { BenutzerTelefoneAktualisierenRequest } from '../model/benutzerTelefoneAktualisierenRequest';
// @ts-ignore
import { BenutzerTelefoneSichtbarkeitRequest } from '../model/benutzerTelefoneSichtbarkeitRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BenutzerverwaltungAdminCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostBenutzerAktivierenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/aktivieren
     * @param benutzerAktivierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerAktivierenAdmin(benutzerAktivierenRequest: BenutzerAktivierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerAktivierenAdmin(benutzerAktivierenRequest: BenutzerAktivierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerAktivierenAdmin(benutzerAktivierenRequest: BenutzerAktivierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerAktivierenAdmin(benutzerAktivierenRequest: BenutzerAktivierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerAktivierenRequest === null || benutzerAktivierenRequest === undefined) {
            throw new Error('Required parameter benutzerAktivierenRequest was null or undefined when calling postBenutzerAktivierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/aktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerAktivierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerAktualisierenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerMitMailExistiertBereits: (BenutzerverwaltungBenutzerMitMailExistiertBereits) 
     * @endpoint post /api/bv/command/admin/v1/aktualisieren
     * @param benutzerNameRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerAktualisierenAdmin(benutzerNameRequest: BenutzerNameRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerAktualisierenAdmin(benutzerNameRequest: BenutzerNameRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerAktualisierenAdmin(benutzerNameRequest: BenutzerNameRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerAktualisierenAdmin(benutzerNameRequest: BenutzerNameRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerNameRequest === null || benutzerNameRequest === undefined) {
            throw new Error('Required parameter benutzerNameRequest was null or undefined when calling postBenutzerAktualisierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerNameRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerAnlegenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerMitMailExistiertBereits: (BenutzerverwaltungBenutzerMitMailExistiertBereits) 
     * @endpoint post /api/bv/command/admin/v1/anlegen
     * @param benutzerAnlegenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerAnlegenAdmin(benutzerAnlegenRequest: BenutzerAnlegenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerAnlegenAdmin(benutzerAnlegenRequest: BenutzerAnlegenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerAnlegenAdmin(benutzerAnlegenRequest: BenutzerAnlegenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerAnlegenAdmin(benutzerAnlegenRequest: BenutzerAnlegenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerAnlegenRequest === null || benutzerAnlegenRequest === undefined) {
            throw new Error('Required parameter benutzerAnlegenRequest was null or undefined when calling postBenutzerAnlegenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerAnlegenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerAnmeldungErstellenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerHatLogin: (BenutzerverwaltungBenutzerHatLogin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/anmeldung-erstellen
     * @param benutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerAnmeldungErstellenAdmin(benutzerRequest: BenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerAnmeldungErstellenAdmin(benutzerRequest: BenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerAnmeldungErstellenAdmin(benutzerRequest: BenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerAnmeldungErstellenAdmin(benutzerRequest: BenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerRequest === null || benutzerRequest === undefined) {
            throw new Error('Required parameter benutzerRequest was null or undefined when calling postBenutzerAnmeldungErstellenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/anmeldung-erstellen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerBackendAdminSetzenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/backend-admin
     * @param benutzerBackendAdminRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerBackendAdminSetzenAdmin(benutzerBackendAdminRequest: BenutzerBackendAdminRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerBackendAdminSetzenAdmin(benutzerBackendAdminRequest: BenutzerBackendAdminRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerBackendAdminSetzenAdmin(benutzerBackendAdminRequest: BenutzerBackendAdminRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerBackendAdminSetzenAdmin(benutzerBackendAdminRequest: BenutzerBackendAdminRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerBackendAdminRequest === null || benutzerBackendAdminRequest === undefined) {
            throw new Error('Required parameter benutzerBackendAdminRequest was null or undefined when calling postBenutzerBackendAdminSetzenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/backend-admin`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerBackendAdminRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerEinladenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * BenutzerHatKeineMailAdresse: (BenutzerverwaltungBenutzerHatKeineMailAdresse) 
     * @endpoint post /api/bv/command/admin/v1/einladen
     * @param benutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerEinladenAdmin(benutzerRequest: BenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerEinladenAdmin(benutzerRequest: BenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerEinladenAdmin(benutzerRequest: BenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerEinladenAdmin(benutzerRequest: BenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerRequest === null || benutzerRequest === undefined) {
            throw new Error('Required parameter benutzerRequest was null or undefined when calling postBenutzerEinladenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/einladen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerEmailAktualisierenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/email/aktualisieren
     * @param benutzerEmailAktualisierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerEmailAktualisierenAdmin(benutzerEmailAktualisierenRequest: BenutzerEmailAktualisierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerEmailAktualisierenAdmin(benutzerEmailAktualisierenRequest: BenutzerEmailAktualisierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerEmailAktualisierenAdmin(benutzerEmailAktualisierenRequest: BenutzerEmailAktualisierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerEmailAktualisierenAdmin(benutzerEmailAktualisierenRequest: BenutzerEmailAktualisierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerEmailAktualisierenRequest === null || benutzerEmailAktualisierenRequest === undefined) {
            throw new Error('Required parameter benutzerEmailAktualisierenRequest was null or undefined when calling postBenutzerEmailAktualisierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/email/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerEmailAktualisierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerEntraIdEntkoppelnAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerEntryIdEntkoppelt: (BenutzerverwaltungBenutzerEntryIdBereitsEntkoppelt) * BenutzerAzureAdOptionsFehlt: (BenutzerverwaltungBenutzerAzureAdOptionsFehlt) * BenutzerHatEntraDomain: (BenutzerverwaltungBenutzerHatEntraDomain) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/entraid/entkoppeln
     * @param benutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerEntraIdEntkoppelnAdmin(benutzerRequest: BenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerEntraIdEntkoppelnAdmin(benutzerRequest: BenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerEntraIdEntkoppelnAdmin(benutzerRequest: BenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerEntraIdEntkoppelnAdmin(benutzerRequest: BenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerRequest === null || benutzerRequest === undefined) {
            throw new Error('Required parameter benutzerRequest was null or undefined when calling postBenutzerEntraIdEntkoppelnAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/entraid/entkoppeln`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerEntraIdKoppelnAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/entraid/koppeln
     * @param benutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerEntraIdKoppelnAdmin(benutzerRequest: BenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerEntraIdKoppelnAdmin(benutzerRequest: BenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerEntraIdKoppelnAdmin(benutzerRequest: BenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerEntraIdKoppelnAdmin(benutzerRequest: BenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerRequest === null || benutzerRequest === undefined) {
            throw new Error('Required parameter benutzerRequest was null or undefined when calling postBenutzerEntraIdKoppelnAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/entraid/koppeln`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerEntraTelefoneSichtbarAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/entratelefone/sichtbarkeit
     * @param benutzerTelefoneSichtbarkeitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerEntraTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerEntraTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerEntraTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerEntraTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerTelefoneSichtbarkeitRequest === null || benutzerTelefoneSichtbarkeitRequest === undefined) {
            throw new Error('Required parameter benutzerTelefoneSichtbarkeitRequest was null or undefined when calling postBenutzerEntraTelefoneSichtbarAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/entratelefone/sichtbarkeit`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerTelefoneSichtbarkeitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerIncidentManagementSichtbarkeitAdmin2
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/incidentmanagement/sichtbarkeit2
     * @param benutzerSichtbarkeitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerIncidentManagementSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerIncidentManagementSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerIncidentManagementSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerIncidentManagementSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerSichtbarkeitRequest === null || benutzerSichtbarkeitRequest === undefined) {
            throw new Error('Required parameter benutzerSichtbarkeitRequest was null or undefined when calling postBenutzerIncidentManagementSichtbarkeitAdmin2.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/incidentmanagement/sichtbarkeit2`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerSichtbarkeitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerLoeschenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/loeschen
     * @param benutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerLoeschenAdmin(benutzerRequest: BenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerLoeschenAdmin(benutzerRequest: BenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerLoeschenAdmin(benutzerRequest: BenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerLoeschenAdmin(benutzerRequest: BenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerRequest === null || benutzerRequest === undefined) {
            throw new Error('Required parameter benutzerRequest was null or undefined when calling postBenutzerLoeschenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/loeschen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerSperrenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/sperren
     * @param benutzerSperrenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerSperrenAdmin(benutzerSperrenRequest: BenutzerSperrenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerSperrenAdmin(benutzerSperrenRequest: BenutzerSperrenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerSperrenAdmin(benutzerSperrenRequest: BenutzerSperrenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerSperrenAdmin(benutzerSperrenRequest: BenutzerSperrenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerSperrenRequest === null || benutzerSperrenRequest === undefined) {
            throw new Error('Required parameter benutzerSperrenRequest was null or undefined when calling postBenutzerSperrenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/sperren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerSperrenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerSyncAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/syncuser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerSyncAdmin(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerSyncAdmin(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerSyncAdmin(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerSyncAdmin(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/syncuser`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTelefonAktualisierenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/telefone/aktualisieren
     * @param benutzerTelefonRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTelefonAktualisierenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTelefonAktualisierenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTelefonAktualisierenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTelefonAktualisierenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerTelefonRequest === null || benutzerTelefonRequest === undefined) {
            throw new Error('Required parameter benutzerTelefonRequest was null or undefined when calling postBenutzerTelefonAktualisierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/telefone/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerTelefonRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTelefonAnlegenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/telefone/anlegen
     * @param benutzerTelefonRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTelefonAnlegenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTelefonAnlegenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTelefonAnlegenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTelefonAnlegenAdmin(benutzerTelefonRequest: BenutzerTelefonRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerTelefonRequest === null || benutzerTelefonRequest === undefined) {
            throw new Error('Required parameter benutzerTelefonRequest was null or undefined when calling postBenutzerTelefonAnlegenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/telefone/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerTelefonRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTelefonEntfernenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/telefone/entfernen
     * @param benutzerTelefonEntfernenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTelefonEntfernenAdmin(benutzerTelefonEntfernenRequest: BenutzerTelefonEntfernenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTelefonEntfernenAdmin(benutzerTelefonEntfernenRequest: BenutzerTelefonEntfernenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTelefonEntfernenAdmin(benutzerTelefonEntfernenRequest: BenutzerTelefonEntfernenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTelefonEntfernenAdmin(benutzerTelefonEntfernenRequest: BenutzerTelefonEntfernenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerTelefonEntfernenRequest === null || benutzerTelefonEntfernenRequest === undefined) {
            throw new Error('Required parameter benutzerTelefonEntfernenRequest was null or undefined when calling postBenutzerTelefonEntfernenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/telefone/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerTelefonEntfernenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTelefoneAktualisierenAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/telefone
     * @param benutzerTelefoneAktualisierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTelefoneAktualisierenAdmin(benutzerTelefoneAktualisierenRequest: BenutzerTelefoneAktualisierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTelefoneAktualisierenAdmin(benutzerTelefoneAktualisierenRequest: BenutzerTelefoneAktualisierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTelefoneAktualisierenAdmin(benutzerTelefoneAktualisierenRequest: BenutzerTelefoneAktualisierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTelefoneAktualisierenAdmin(benutzerTelefoneAktualisierenRequest: BenutzerTelefoneAktualisierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerTelefoneAktualisierenRequest === null || benutzerTelefoneAktualisierenRequest === undefined) {
            throw new Error('Required parameter benutzerTelefoneAktualisierenRequest was null or undefined when calling postBenutzerTelefoneAktualisierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/telefone`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerTelefoneAktualisierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTelefoneSichtbarAdmin
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/telefone/sichtbarkeit
     * @param benutzerTelefoneSichtbarkeitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTelefoneSichtbarAdmin(benutzerTelefoneSichtbarkeitRequest: BenutzerTelefoneSichtbarkeitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerTelefoneSichtbarkeitRequest === null || benutzerTelefoneSichtbarkeitRequest === undefined) {
            throw new Error('Required parameter benutzerTelefoneSichtbarkeitRequest was null or undefined when calling postBenutzerTelefoneSichtbarAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/telefone/sichtbarkeit`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerTelefoneSichtbarkeitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostBenutzerTroubleTicketsSichtbarkeitAdmin2
     * ORGA App Zugriff: * Mandant: Admin  Problem Types: * KeinMandantAdmin: (KeinMandantAdmin) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerGeloescht: (BenutzerverwaltungBenutzerGeloescht) 
     * @endpoint post /api/bv/command/admin/v1/troubletickets/sichtbarkeit2
     * @param benutzerSichtbarkeitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postBenutzerTroubleTicketsSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BenutzerIdentifier>;
    public postBenutzerTroubleTicketsSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BenutzerIdentifier>>;
    public postBenutzerTroubleTicketsSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BenutzerIdentifier>>;
    public postBenutzerTroubleTicketsSichtbarkeitAdmin2(benutzerSichtbarkeitRequest: BenutzerSichtbarkeitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (benutzerSichtbarkeitRequest === null || benutzerSichtbarkeitRequest === undefined) {
            throw new Error('Required parameter benutzerSichtbarkeitRequest was null or undefined when calling postBenutzerTroubleTicketsSichtbarkeitAdmin2.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/admin/v1/troubletickets/sichtbarkeit2`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BenutzerIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: benutzerSichtbarkeitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
